import { render } from "./HistoryChange.vue?vue&type=template&id=33f07786"
import script from "./HistoryChange.vue?vue&type=script&lang=js"
export * from "./HistoryChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__